import React from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom"

import { useAppSelector } from "../../redux"
import {
  Divider,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@podcastsoundboard/ps-lib/ui"
import FormatListBulletedIcon from "@podcastsoundboard/ps-lib/ui/icons/FormatListBulleted"
import GraphicEqIcon from "@podcastsoundboard/ps-lib/ui/icons/GraphicEq"
import HelpIcon from "@podcastsoundboard/ps-lib/ui/icons/Help"
import LocalActivityIcon from "@podcastsoundboard/ps-lib/ui/icons/LocalActivity"
import MusicVideoIcon from "@podcastsoundboard/ps-lib/ui/icons/MusicVideo"
import PasswordIcon from "@podcastsoundboard/ps-lib/ui/icons/Password"
import PersonIcon from "@podcastsoundboard/ps-lib/ui/icons/Person"
import SettingsIcon from "@podcastsoundboard/ps-lib/ui/icons/Settings"

const NavListItem = (props) => {
  const { open, path, title, icon, primary, secondary } = props

  const navigate = useNavigate()
  const location = useLocation()

  const showTitle = title || primary
  return (
    <Tooltip title={!open ? showTitle : false} placement="right">
      <div style={{ cursor: "pointer" }}>
        <ListItemButton
          className="pl-[15px]"
          selected={location.pathname.startsWith(path)}
          onClick={() => navigate(path)}
        >
          <ListItemIcon>{icon}</ListItemIcon>
          <ListItemText primary={primary} secondary={secondary} />
        </ListItemButton>
      </div>
    </Tooltip>
  )
}

const AccountListItems: React.FC<{ open?: boolean }> = ({ open }) => {
  const { soundboardUuid } = useParams()
  const darkModeEnabled = useAppSelector((state) => state.darkModeEnabled)

  const [lastSeenSoundboardUuid, setLastSeenSoundboardUuid] = React.useState<
    string | null
  >(null)
  React.useEffect(() => {
    if (soundboardUuid) {
      setLastSeenSoundboardUuid(soundboardUuid)
    }
  }, [soundboardUuid])

  return (
    <>
      <NavListItem
        open={open}
        path={
          lastSeenSoundboardUuid
            ? `/app/account/soundboards/${lastSeenSoundboardUuid}`
            : "/app/account/soundboards/new"
        }
        title="Soundboards"
        icon={<MusicVideoIcon />}
        primary="Soundboards"
        secondary="Create, edit, and play"
      />

      <Divider />

      <NavListItem
        open={open}
        icon={<FormatListBulletedIcon />}
        primary="Boards"
        path="/app/account/management"
      />
      <NavListItem
        open={open}
        icon={<GraphicEqIcon />}
        primary="Files"
        path="/app/account/sounds"
      />

      <NavListItem
        open={open}
        icon={<SettingsIcon />}
        primary="Settings"
        path="/app/account/settings"
      />

      <Divider />

      <NavListItem
        open={open}
        path="/app/account/profile"
        primary="Profile"
        icon={<PersonIcon />}
      />

      <NavListItem
        open={open}
        path="/app/account/subscription"
        primary="Subscription"
        icon={<LocalActivityIcon />}
      />

      <NavListItem
        path="/app/account/windows-licenses"
        open={open}
        primary="Windows"
        icon={
          <img
            style={{
              height: "1.4rem",
              width: "1.4rem",
              paddingLeft: "3px",
              marginRight: "4px",
              // match ListItemIcon's text-secondary (white/black at ~60%)
              opacity: darkModeEnabled ? 0.64 : 0.6,
            }}
            alt="Windows"
            src={
              darkModeEnabled ? "/img/windows.svg" : "/img/windows-black.svg"
            }
          />
        }
      />

      <NavListItem
        path="/app/account/change-password"
        open={open}
        primary="Change Password"
        icon={<PasswordIcon />}
      />

      <Divider />

      <NavListItem
        open={open}
        icon={<HelpIcon />}
        primary="Help"
        path="/app/account/help"
      />
    </>
  )
}
export default AccountListItems
